import * as React from 'react'
import classnames from 'classnames'
import { Image } from '@/atoms/Image'
import { AsH2, CaptionSM, HeadingMD, ParagraphSM } from '@/atoms/Text'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { useSafeAnalytics } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { TorchSubmitButton } from '@/views/SubmitView/TorchSubmitButton'

interface GuildMemberVotingProps extends React.HTMLAttributes<HTMLDivElement> {}

const GuildMemberVoting = (props: GuildMemberVotingProps) => {
  const { className, ...rest } = props
  const { track } = useSafeAnalytics()
  const { t } = useTranslate('filmmaker')

  const handleGetStartedClicked = React.useCallback(() => {
    track('Guild Submit Project Clicked')
  }, [track])

  return (
    <div
      className={classnames(
        'mx-auto flex max-w-[750px] flex-col gap-8 px-3 pb-[120px] pt-10 2xl:grid 2xl:max-w-[1488px] 2xl:grid-cols-[560px_1fr] 2xl:gap-[120px]',
        className,
      )}
      {...rest}
    >
      <div className="flex flex-col gap-6 2xl:max-w-[560px]">
        <HeadingMD color="white" weight="bold" as={AsH2}>
          {t('howManyVote', 'How many of them vote on my project?')}
        </HeadingMD>
        <ParagraphSM color="core-gray-400">
          {t(
            'guildDecideDescription',
            'While all Guild members can vote, only a statistically significant sample, representing diverse demographics, is needed to decide what advances. Qualified submissions start seeing votes within a week.',
          )}
        </ParagraphSM>
        <div className="flex flex-col items-start gap-3">
          <TorchSubmitButton handleSubmitClicked={handleGetStartedClicked} isDark={true} />
          <CaptionSM color="core-gray-500">{t('applicationFee', '$250 application fee')}</CaptionSM>
        </div>
      </div>
      <div className="flex flex-row justify-center">
        <Image
          src={getCloudinaryImageUrl({
            path: 'v1765479891/angel-studios/filmmaker/Chat.webp',
          })}
          alt="Informational chat bubbles"
          width={0}
          height={0}
          sizes="100vw"
          className="h-full w-full max-w-[554px]"
        />
      </div>
    </div>
  )
}

export { GuildMemberVoting }
